export default __webpack_public_path__ + "static/media/le_croise5.c4fc6a42.jpg";